






import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class QuestionCounter extends Vue {
  @Prop(Array) public askedQuestionsList!: Array<String>

  get questionCounterInfo () {
    const maxQuestions = this.$store.getters['maxQuestions']
    const countQuestions = this.askedQuestionsList ? this.askedQuestionsList.length : 0
    return `${this.askedQuestionsList.length} / ${maxQuestions}`
  }
}
